var map = {
	".": "KJg6",
	"./": "KJg6",
	"./01_get_user_balance": "zKw2",
	"./01_get_user_balance.json": "zKw2",
	"./02_get_user_positions": "uAAZ",
	"./02_get_user_positions.json": "uAAZ",
	"./03_get_user_income": "clol",
	"./03_get_user_income.json": "clol",
	"./18_get_trade_income_export": "tvLy",
	"./18_get_trade_income_export.json": "tvLy",
	"./19_get_trade_user_commissionRate": "IIQZ",
	"./19_get_trade_user_commissionRate.json": "IIQZ",
	"./index": "KJg6",
	"./index.js": "KJg6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "J7Xj";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/api/account ^.*$
// module id = J7Xj
// module chunks = 3